// DEPRECATED(legacy-tables): legacy table. Use ServerDataGrid instead.
import '@sophocles/components/DataTable2/styles.scss';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { CircularProgress, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Popover from '@mui/material/Popover';
import { List, Map, fromJS } from 'immutable';
import _ from 'lodash';
import objectAssign from 'object-assign';
import pluralize from 'pluralize';
import React from 'react';
import { withTranslation } from 'react-i18next';

import PagingSection from '@sophocles/components/DataTable2/PagingSection';
import SearchField from '@sophocles/components/SearchField';
import WindowSizeHOC from '@sophocles/components/WindowSizeHOC';
import { windowSizes } from '@sophocles/utils';

class DataTable extends React.Component {
  constructor(props) {
    super(props);

    const { defaultEntryCount, entryCountOptions, defaultSortBy, defaultSortDesc, defaultSearch, defaultPage } =
      this.props;

    const realEntryCount =
      entryCountOptions.indexOf(defaultEntryCount) != -1 ? defaultEntryCount : entryCountOptions[0];
    this.fetchNumber = 0;

    this.state = {
      fetching: false,
      data: List(),
      page: defaultPage,
      resultCount: 0, // get this from fetching
      entryCount: realEntryCount,
      search: defaultSearch || '',
      sortBy: defaultSortBy,
      sortDesc: defaultSortDesc,
    };
  }

  needToFetchData = () => !!this.props.fetchData;

  componentDidMount() {
    const { defaultEntryCount } = this.props;
    if (this.needToFetchData()) {
      const { page, entryCount, search, sortBy, sortDesc, searchFields } = this._getValues();
      this._fetchData(entryCount, page, search, sortBy, sortDesc, searchFields);
    } else {
      this.onEntryCountChange(null, defaultEntryCount);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { defaultEntryCount } = this.props;
    if (
      !_.isEqual(nextProps.watchForChanges, this.props.watchForChanges) ||
      !_.isEqual(nextProps.searchFields, this.props.searchFields)
    ) {
      const { page, entryCount, search, sortBy, sortDesc, searchFields } = this._getValues(nextProps);
      this._setPage(1);
      this._rawFetchData(nextProps.fetchData, entryCount, 1, search, sortBy, sortDesc, searchFields);

      // If there is an external property we don't want to update the count and refetch the raw data.
      if (!(this.props.externalSearch || this.props.externalFilter)) {
        this.onEntryCountChange(null, defaultEntryCount);
      }
    }
  }

  _getDataAndResultCount = () => {
    // if the data is coming from a fetch call, then use the data in state.
    if (this.needToFetchData()) {
      return { data: this.state.data, resultCount: this.state.resultCount };
    }

    // otherwise, we have to do our own search, sort, and slicing
    const { page, entryCount, search, sortBy, sortDesc, searchFields } = this._getValues();
    const { data, columns, skipSearch } = this.props;

    const sortColumn = columns.find(column =>
      column.has('param') ? column.get('param') == sortBy : column.get('id') == sortBy,
    );

    const searchTerms = search.split(' '); // each entry must match each search term in atleast one field,

    const searchedData =
      search == '' || skipSearch
        ? data
        : data.filter(entry =>
            List(searchTerms).every(term => {
              const l_term = term.toLowerCase();
              return List(searchFields).some(field => {
                const v = entry.get(field, null);
                return v ? (v + '').toLowerCase().indexOf(l_term) > -1 : false;
              });
            }),
          );

    const sortedData = searchedData
      .sortBy(entry => entry.get(sortBy, ''), sortColumn.get('sortComparator', undefined))
      .update(list => (sortDesc ? list.reverse() : list));

    const resultCount = searchedData.size;

    const baseShowingCount = entryCount > 0 ? (page - 1) * entryCount : 0;
    const lastResultShown =
      resultCount - baseShowingCount >= entryCount && entryCount > 0
        ? parseInt(baseShowingCount) + parseInt(entryCount)
        : resultCount;

    return { data: sortedData.slice(baseShowingCount, lastResultShown), resultCount };
  };

  _setSortBy = value => {
    const { setSortBy } = this.props;
    typeof setSortBy === 'function' ? setSortBy(value) : this.setState({ sortBy: value });
  };

  _setSortDesc = value => {
    const { setSortDesc } = this.props;
    typeof setSortDesc === 'function' ? setSortDesc(value) : this.setState({ sortDesc: value });
  };

  _setPage = value => {
    const { setPage } = this.props;
    typeof setPage === 'function' ? setPage(value) : this.setState({ page: value });
  };

  _setEntryCount = value => {
    const { setEntryCount } = this.props;
    typeof setEntryCount === 'function' ? setEntryCount(value) : this.setState({ entryCount: value });
  };

  _setSearch = value => {
    const { setSearch } = this.props;
    typeof setSearch === 'function' ? setSearch(value) : this.setState({ search: value });
  };

  _getValues = (givenProps = null) => {
    const fields = ['page', 'entryCount', 'search', 'sortBy', 'sortDesc', 'searchFields'];
    return _.defaults({}, _.pick(givenProps || this.props, fields), _.pick(this.state, fields));
  };

  _rawFetchData = (fetchFunction, limit, page, searchText, sort, sortDesc, searchFields) => {
    const offset = (page - 1) * limit;

    const search = searchText && searchFields ? searchFields.join(',') + '|' + searchText.split(' ').join(',') : false;
    this.setState({ fetching: true });

    this.fetchNumber += 1;
    const currentFetchNumber = this.fetchNumber;
    // handle the 'all' case which is -1 limit
    const fixedLimit = limit > 0 ? limit : 0;
    const fixedOffset = limit > 0 ? offset : 0;

    fetchFunction({
      limit: fixedLimit,
      offset: fixedOffset,
      search,
      sort,
      sortDesc,
    }).then(res => {
      if (currentFetchNumber == this.fetchNumber) {
        this.setState({ data: res.get('results', List()), resultCount: res.get('count', 0), fetching: false });
      }
    });
  };

  _fetchData = (limit, page, searchText, sort, sortDesc, searchFields) => {
    const { fetchData } = this.props;
    this._rawFetchData(fetchData, limit, page, searchText, sort, sortDesc, searchFields);
  };

  _showSortArrow = (column, sortBy, sortDesc) => {
    const sortField = column.has('param') ? 'param' : 'id';

    return column.get(sortField) == sortBy ? (
      sortDesc ? (
        <ExpandLess
          sx={{
            display: 'flex',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            bottom: 0,
            right: 0,
            fill: 'var(--md-primary)',
          }}
        />
      ) : (
        <ExpandMore
          sx={{
            display: 'flex',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            bottom: 0,
            right: 0,
            fill: 'var(--md-primary)',
          }}
        />
      )
    ) : null;
  };

  _getTdStyle = (header, row, rowIndex, sortBy) => {
    const { selectedRowIndicator } = this.props;

    if (typeof selectedRowIndicator === 'function') {
      const result = selectedRowIndicator(row);
      if (result) {
        return { textAlign: header.get('align', 'left'), backgroundColor: result };
      }
    }

    const sortField = header.has('param') ? 'param' : 'id';

    const bgColor =
      header.get(sortField) == sortBy
        ? rowIndex % 2 == 0
          ? 'var(--grid-row-alt-bg)'
          : 'var(--grid-row-alt-bg-tinted)'
        : undefined;

    return { textAlign: header.get('align', 'left'), backgroundColor: bgColor };
  };

  onChangePage = page => {
    const { entryCount, search, sortBy, sortDesc, searchFields } = this._getValues();

    this._setPage(page);
    if (this.needToFetchData()) {
      this._fetchData(entryCount, page, search, sortBy, sortDesc, searchFields);
    }
  };

  onEntryCountChange = (event, count) => {
    const newEntryCount = event && event.target && event.target.value ? event.target.value : count;
    const { page, entryCount, sortBy, sortDesc, search, searchFields } = this._getValues();
    // we want to keep the first result on the table, even though we are changing the number of entries to show.
    const firstResultShown = (page - 1) * entryCount + 1;
    // find what page the result would land on
    const newPage = Math.ceil(firstResultShown / newEntryCount);

    this._setEntryCount(newEntryCount);
    this._setPage(newPage);
    if (this.needToFetchData()) {
      this._fetchData(newEntryCount, newPage, search, sortBy, sortDesc, searchFields);
    }
  };

  onSortChange = field => {
    // set sortBy, set sortDesc
    const { page, entryCount, search, sortDesc, sortBy, searchFields } = this._getValues();
    // const { page, entryCount, search, sortDesc, sortBy} = this.state;
    let newSortDesc = false;

    field != sortBy ? this._setSortBy(field) : (newSortDesc = !sortDesc);

    this._setSortDesc(newSortDesc);

    if (this.needToFetchData()) {
      this._fetchData(entryCount, page, search, field, newSortDesc, searchFields);
    }
  };

  handleChangeSearchQuery = newValue => {
    this._setSearch(newValue);
  };

  handleSearchKeyDown = (e, searchValue) => {
    if (e.keyCode === 13) {
      const { entryCount, sortDesc, sortBy, searchFields } = this._getValues();
      this._setPage(1);
      if (this.needToFetchData()) {
        this._fetchData(entryCount, 1, searchValue, sortBy, sortDesc, searchFields);
      }
    }
  };

  handleSearchClick = searchValue => {
    const { entryCount, sortDesc, sortBy, searchFields } = this._getValues();
    this._setPage(1);
    if (this.needToFetchData()) {
      this._fetchData(entryCount, 1, searchValue, sortBy, sortDesc, searchFields);
    }
  };

  rowColorRenderer = (row, rowIndex) => {
    const { selectedRowIndicator } = this.props;

    if (typeof selectedRowIndicator === 'function') {
      const result = selectedRowIndicator(row);
      if (result) {
        return result;
      }
    }

    return rowIndex % 2 == 0 ? 'var(--surface-primary)' : 'var(--grid-row-alt-bg)';
  };

  _noRowsRenderer = () => (
    <div
      style={{
        color: 'var(--text-muted)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '200px',
        width: '100%',
      }}
    >
      {this.props.noResultsMessage || 'No Data'}
    </div>
  );

  selectSingleValue = value => {
    const { setSelected, selected, selectedFormatter } = this.props;

    const formattedValue = selectedFormatter(value);
    if (selected.contains(formattedValue)) {
      // remove it
      setSelected(selected.delete(formattedValue));
    } else {
      // add it
      setSelected(selected.add(formattedValue));
    }
  };

  selectAll = () => {
    // set fetching to true, then let the last fetch set it to false.
    const { fetchData, setSelected, selectedFormatter, data, skipSearch } = this.props;

    const { sortBy, sortDesc, search: searchText, searchFields, entryCount, page } = this._getValues();

    if (this.needToFetchData()) {
      const search =
        searchText && searchFields ? searchFields.join(',') + '|' + searchText.split(' ').join(',') : false;
      this.setState({ fetching: true });

      return this._recursiveSelectData(fetchData, 0, 100, search, sortBy, sortDesc);
    }

    const searchTerms = searchText.split(' '); // each entry must match each search term in atleast one field,

    const searchedData =
      searchText == '' || skipSearch
        ? data
        : data.filter(entry =>
            List(searchTerms).every(term => {
              const l_term = term.toLowerCase();
              return List(searchFields).some(field => {
                const v = entry.get(field, null);
                return v ? (v + '').toLowerCase().indexOf(l_term) > -1 : false;
              });
            }),
          );

    // return { data: sortedData.slice(baseShowingCount, lastResultShown), resultCount };

    return setSelected(searchedData.map(selectedFormatter).toSet());
  };

  _recursiveSelectData = (fetchFunction, offset, limit, search, sort, sortDesc) => {
    const { setSelected, selected, selectedFormatter } = this.props;

    fetchFunction({
      limit,
      offset,
      search,
      sort,
      sortDesc,
    }).then(res => {
      if (res.error) {
        this.setState({ fetching: false });
        return alert('Error trying to select all data.');
      }

      // get the data and select it.
      const data = res.get('results', List());
      setSelected(selected.union(data.map(selectedFormatter)));

      // then check if there is more data to get.
      if (res.get('next', null) !== null) {
        this._recursiveSelectData(fetchFunction, offset + limit, limit, search, sort, sortDesc);
      }
      // no more data, process is done.
      else {
        this.setState({ fetching: false });
      }
    });
  };

  selectPage = () => {
    const { setSelected, selected, selectedFormatter } = this.props;
    if (this.needToFetchData()) {
      return setSelected(selected.union(this.state.data.map(selectedFormatter)));
    }
    return setSelected(selected.union(this._getDataAndResultCount().data.map(selectedFormatter)));
  };

  deselectAll = () => {
    const { setSelected, selected } = this.props;
    setSelected(selected.clear());
  };

  render() {
    const { entryCount, page, search, sortBy, sortDesc } = this._getValues();

    const { fetching } = this.state;

    const {
      entryCountOptions,
      hideResults,
      hideSearch,
      hidePaging,
      footer,
      selected,
      selectedFormatter,
      extraSelectedComponent,
      windowWidth,
      t,
    } = this.props;

    let { columns } = this.props;

    const onMobile = windowWidth <= windowSizes.mobile.width;

    const hideEntryCountOptions = entryCountOptions.length === 1;

    const { data, resultCount } = this._getDataAndResultCount();

    const totalPageCount = Math.ceil(resultCount / entryCount);

    const baseShowingCount = (page - 1) * entryCount;
    const firstResultShown = baseShowingCount + 1;
    const lastResultShown =
      resultCount - baseShowingCount >= entryCount && entryCount > 0
        ? parseInt(baseShowingCount) + parseInt(entryCount)
        : resultCount;

    const showingString =
      resultCount > 0
        ? `${t('general.showing')} ${
            entryCount > 0 ? firstResultShown : 1
          }-${lastResultShown} / ${resultCount} ${pluralize(t('general.entries'), resultCount)}`
        : t('general.noResultsMessage');

    if (selected) {
      columns = columns.unshift(
        fromJS({
          name: '',
          id: 'unused_id',
          style: { width: '60px' },
          sortable: false,
          cellRenderer: (value, row) => (
            <div style={{}}>
              <Checkbox
                style={{ width: '30px' }}
                inputStyle={{ width: '30px' }}
                checked={selected.contains(selectedFormatter(row))}
                onChange={() => this.selectSingleValue(row)}
              />
            </div>
          ),
        }),
      );
    }

    return (
      <div
        style={{ position: 'relative', overflowY: 'auto', overflowX: 'auto', marginBottom: '60px', paddingTop: '15px' }}
        data-testid="DataTable"
      >
        {fetching && (
          <div
            style={{
              width: '100%',
              height: '100%',
              zIndex: 5,
              backgroundColor: 'rgba(153, 153, 153, 0.3)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'absolute',
              left: 0,
              top: 0,
            }}
          >
            <CircularProgress />
          </div>
        )}

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: '16px',
            paddingLeft: '8px',
            paddingRight: '8px',
          }}
        >
          {hideEntryCountOptions || onMobile ? (
            hideSearch ? null : (
              <span>&nbsp;</span>
            )
          ) : (
            <div>
              <Box>
                <FormControl>
                  <InputLabel id="entry-count-select-label">{t('general.numEntries')}</InputLabel>
                  <Select
                    labelId="entry-count-select-label"
                    size="small"
                    label={t('general.numEntries')}
                    onChange={this.onEntryCountChange}
                    value={entryCount}
                    sx={{ minWidth: '100px' }}
                  >
                    {entryCountOptions.map(
                      op =>
                        op != -1 && (
                          <MenuItem key={op} value={op}>
                            {op}
                          </MenuItem>
                        ),
                    )}
                  </Select>
                </FormControl>
              </Box>
            </div>
          )}

          {hideSearch ? (
            hideEntryCountOptions ? null : (
              <span>&nbsp;</span>
            )
          ) : (
            <SearchField
              value={search}
              onChange={value => this.handleChangeSearchQuery(value)}
              onKeyDown={e => this.handleSearchKeyDown(e, search)}
              onSearch={value => {
                if (search !== value) {
                  this.handleChangeSearchQuery(value);
                }
                this.handleSearchClick(value);
              }}
            />
          )}
        </div>

        {!!selected && (
          <div style={{ paddingTop: '8px', display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <SelectionMenu
                totalCount={resultCount}
                pageCount={data.size}
                selectOnPage={this.selectPage}
                selectAll={this.selectAll}
                deselectAll={this.deselectAll}
              />
              <div style={{ fontSize: '14px', marginLeft: '8px' }}>
                selected: {selected.size} {pluralize('entries', selected.count())}
              </div>
            </div>
            {extraSelectedComponent}
          </div>
        )}

        <table style={{ textAlign: 'left', width: '100%', fontSize: '14px' }} className="dt2-table">
          <thead>
            <tr style={{ fontWeight: 'bold', borderBottom: '1px solid var(--md-primary)' }}>
              {columns &&
                columns.map((header, index) => (
                  <th
                    key={index}
                    style={objectAssign(
                      {},
                      { cursor: header.get('sortable', true) ? 'pointer' : 'default' },
                      header.get('style', Map()).toObject(),
                    )}
                    onClick={
                      header.get('sortable', true)
                        ? () => this.onSortChange(header.get('param', header.get('id')))
                        : null
                    }
                  >
                    <span>{header.get('name', 'None')}</span>
                    {this._showSortArrow(header, sortBy, sortDesc)}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {data.size > 0 &&
              data.map((row, rowIndex) => (
                <tr key={rowIndex} style={{ backgroundColor: this.rowColorRenderer(row, rowIndex) }}>
                  {columns.map((header, colIndex) => {
                    let value = row.get(header.get('id'), '');

                    // has a cellRenderer
                    if (typeof header.get('cellRenderer', '') === 'function') {
                      const cellRenderer = header.get('cellRenderer');
                      value = cellRenderer(value, row, rowIndex);
                    }

                    return (
                      <td key={colIndex} style={this._getTdStyle(header, row, rowIndex, sortBy)}>
                        {value}
                      </td>
                    );
                  })}
                </tr>
              ))}
            {footer}
          </tbody>
        </table>

        {data.size == 0 && this._noRowsRenderer()}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: '8px',
            flexWrap: 'wrap',
          }}
        >
          {hideResults ? (
            hidePaging ? null : (
              <span>&nbsp;</span>
            )
          ) : (
            <div style={{ padding: '4px', fontSize: '14px' }}>{showingString}</div>
          )}
          {hidePaging ? (
            hideResults ? null : (
              <span>&nbsp;</span>
            )
          ) : (
            <div>
              <PagingSection
                currentPage={page < 1 ? 0 : parseInt(page)}
                totalPages={totalPageCount < 1 ? 0 : totalPageCount}
                onPageSelect={this.onChangePage}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

DataTable.defaultProps = {
  entryCountOptions: [10, 25, 50, 100],
  defaultEntryCount: 10,
  defaultSortBy: null,
  defaultSortDesc: false,
  defaultPage: 1,
  skipSearch: false,
  noResultsMessage: null,
  selected: false,
  setSelected: v => console.warn('value not selected, must pass in your own setSelected prop to the DataTable'),
  selectedFormatter: v => v, // function to determine what is stored from the selected value
  selectedComparisonValueGetter: v => v.get('id'), // function returns the value that is compared for each entry.
  extraSelectedComponent: null,
  externalSearch: false,
  externalFilter: false,
};

export default withTranslation()(WindowSizeHOC(DataTable));

const menuItemStyle = {
  color: 'var(--md-primary)',
  cursor: 'pointer',
};

class SelectionMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  openMenu = event =>
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });

  closeMenu = () => this.setState({ open: false });

  render() {
    const { open } = this.state;
    const { pageCount, totalCount, selectOnPage, selectAll, deselectAll } = this.props;

    const funcThenClose = func => () => {
      func();
      this.closeMenu();
    };

    return (
      <div style={{}}>
        <button className="btn btn-sm btn-outline-primary" onClick={this.openMenu}>
          All {open ? <ExpandLess /> : <ExpandMore />}
        </button>

        <Popover
          open={open}
          anchorEl={this.state.anchorEl}
          onClose={this.closeMenu}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          useLayerForClickAway={false}
        >
          <div style={{ padding: '12px 12px 4px', maxHeight: '100%' }}>
            <div onClick={funcThenClose(selectOnPage)} style={menuItemStyle}>
              Select all {pageCount} on this page
            </div>
            <div onClick={funcThenClose(selectAll)} style={menuItemStyle}>
              Select all {totalCount} results
            </div>
            <div onClick={funcThenClose(deselectAll)} style={menuItemStyle}>
              deselect all
            </div>
          </div>
        </Popover>
      </div>
    );
  }
}
